















































import Vue from 'vue';
import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import { mapGetters } from 'vuex';
import { errorToMessage } from '@/core/utils/errors';
import DirtyMixin from '@/web/mixins/DirtyMixin';
import { getStudentViewURL } from '@/web/router/custom-domain-utils';

export default Vue.extend({
  name: 'Quiz',
  mixins: [DirtyMixin],
  components: {
    TopNav,
    NavItem,
  },
  props: {
    hideOverview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inProgress: false,
      previewInProgress: false,
    };
  },
  computed: {
    ...mapGetters({
      quiz: 'quiz/quiz',
      formSaveFun: 'globals/formSaveFun',
      teacher: 'user/teacher',
      teacherMagicCode: 'user/teacherMagicCode',
    }),
    selectedTab: {
      get() {
        const selectedTab = this.tabs.find(
          ({ routeName }) => this.$route.name === routeName
        );
        return selectedTab?.name;
      },
      set(tabName) {
        const routeName = this.tabs.find(({ name }) => name === tabName)
          .routeName;
        this.$router.replace({ name: routeName });
      },
    },
    nextTab() {
      const selectedTabIndex = this.tabs.findIndex(
        ({ name }) => name === this.selectedTab
      );
      return this.tabs[selectedTabIndex + 1];
    },
    tabs() {
      return [
        {
          name: 'overview',
          title: 'QUIZZES.LABEL.OVERVIEW',
          routeName: 'quiz-overview',
          hide: this.hideOverview,
        },
        {
          name: 'settings',
          title: 'QUIZZES.LABEL.SETTINGS',
          routeName: 'quiz-settings',
        },
        {
          name: 'content',
          title: 'QUIZZES.LABEL.CONTENT',
          routeName: 'quiz-content',
        },
        {
          name: 'submissions',
          title: 'QUIZZES.LABEL.SUBMISSIONS',
          routeName: 'quiz-submissions',
        },
      ];
    },
  },
  async mounted() {
    try {
      const id = this.$route.params.id;
      await this.$store.dispatch('quiz/getQuiz', id);
      this.clearDirty();
    } catch (error) {
      this.$notify({
        group: 'app',
        type: 'error',
        title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
        text: errorToMessage(
          error.response,
          `${this.$t(
            'QUIZZES.NOTIFICATIONS.FAILED_TO_LOAD_QUIZ_STATS'
          )}: ${error}`
        ),
        duration: -1,
      });
    }
  },
  methods: {
    async saveQuiz() {
      if (!this.formSaveFun) return;
      this.inProgress = true;
      try {
        await this.formSaveFun();
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS') as string,
          text: this.$t('QUIZZES.NOTIFICATIONS.QUIZ_SUCCESSFULLY_UPDATED'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(
            error.response,
            `${this.$t('QUIZZES.NOTIFICATIONS.FAILED_TO_SAVE_QUIZ')}: ${error}`
          ),
        });
      } finally {
        this.inProgress = false;
      }
    },
    getStudentPreviewURL(studioUrl, quizId) {
      return getStudentViewURL(
        studioUrl,
        `/quiz/${quizId}`,
        this.teacherMagicCode
      );
    },
    async openPreview() {
      this.previewInProgress = true;

      try {
        await this.$store.dispatch(
          'quiz/deleteTeacherQuizSubmission',
          this.quiz.id
        );
        window.open(
          this.getStudentPreviewURL(this.teacher.studio_url, this.quiz.id),
          '_blank'
        );
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(error.response, error),
        });
      } finally {
        this.previewInProgress = false;
      }
    },
  },
});
